import { apiClient } from "@/shared/api/client";
import type { ShiftEvent } from "@/features/shift-events/types";

interface GpsPayload {
  gps_lat: number | null;
  gps_lng: number | null;
  gps_accuracy?: number | null;
}

export async function checkIn(shiftId: string, gps: GpsPayload): Promise<ShiftEvent> {
  const { data } = await apiClient.post<ShiftEvent>(`/shifts/${shiftId}/checkin`, gps);
  return data;
}

export async function checkOut(shiftId: string, gps: GpsPayload): Promise<ShiftEvent> {
  const { data } = await apiClient.post<ShiftEvent>(`/shifts/${shiftId}/checkout`, gps);
  return data;
}

export async function listEvents(shiftId: string): Promise<ShiftEvent[]> {
  const { data } = await apiClient.get<ShiftEvent[]>(`/shifts/${shiftId}/events`);
  return data;
}
